import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';
import SingleScoreCard from './SingleScoreCard';
import BulkScoreCard from './BulkScoreCard';
import { viewListingScore, viewScoreBatch } from '../utils/scoreNavigation';
import { PROJECT_TYPE_LABELS } from '../hooks/useProjectTypeFilter';
import styles from '../ManagePage.module.css';

// Listing-score history for the Manage page's listing-score filter view.
// Data comes from useListingScoreHistory in ManagePage so the merged default
// grid and this view share one fetch.
const ListingScoreSection = ({ data }) => {
  const navigate = useNavigate();
  const { loading, error, combinedItems } = data;
  const hasAny = combinedItems.length > 0;

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionHeaderTitle}>
          <span className={styles.allProjectsTitle}>{PROJECT_TYPE_LABELS.listing_score} ({combinedItems.length})</span>
        </div>
      </div>
      {loading && (
        <div className={styles.loading}><FaSpinner className={styles.spinner} /></div>
      )}
      {error && !loading && (
        <div className={styles.error}>{error}</div>
      )}
      {!loading && !error && !hasAny && (
        <div className={styles.emptyState}>
          <h3>No listing score results</h3>
          <p>Run a single or bulk listing score analysis to see results here.</p>
        </div>
      )}
      {!loading && !error && hasAny && (
        <div className={styles.smallCardsGrid}>
          {combinedItems.map((item) =>
            item.type === 'batch' ? (
              <BulkScoreCard
                key={item.key}
                batch={item.batch}
                onClick={() => viewScoreBatch(navigate, item.batch)}
              />
            ) : (
              <SingleScoreCard
                key={item.key}
                result={item.result}
                onViewScore={(asin, scoreData) => viewListingScore(navigate, asin, scoreData)}
              />
            )
          )}
        </div>
      )}
    </div>
  );
};

export default ListingScoreSection;
